import {combineReducers} from 'redux';

import {auth} from 'src/shared/auth/reducers';
import {channelLineup} from 'src/shared/channelLineup/reducers';
import {config} from 'src/shared/config/reducers';
import {params} from 'src/shared/params/reducers';
import {resourceStatus} from 'src/shared/resourceStatus/reducers';
import {user} from 'src/shared/user/reducers';
import {address} from 'src/pages/localChannelLineup/store/reducers/address';
import {showFirstName} from 'src/pages/localChannelLineup/store/reducers/showFirstName';
import {filter} from 'src/pages/localChannelLineup/store/reducers/filter';
import {lineupOrder} from 'src/pages/localChannelLineup/store/reducers/lineupOrder';
import {locationSuggestions} from 'src/shared/locationSuggestions/reducers';
import {MDIUserSession, session} from 'src/pages/deviceInfo/store/reducers/deviceInfo';
import {datacast} from 'src/shared/datacast/reducers';

export const reducers = combineReducers({
  address,
  showFirstName,
  auth,
  channelLineup,
  config,
  datacast,
  filter,
  lineupOrder,
  params,
  session,
  MDIUserSession,
  resourceStatus,
  user,
  locationSuggestions,
});
